export const WORKER_AVERAGE_REQUEST = 'WORKER_AVERAGE_REQUEST';
export const WORKER_AVERAGE_SUCCESS = 'WORKER_AVERAGE_SUCCESS';
export const SET_WORKER_AVERAGE_SUMMURY = 'SET_WORKER_AVERAGE_SUMMURY';
export const WORKER_AVERAGE_REQUEST_FAILURE = 'WORKER_AVERAGE_REQUEST_FAILURE';
export const SET_PRODUCTION_TRANSACTION_ID = 'SET_PRODUCTION_TRANSACTION_ID'